/**
 * Hook to initialize layout on mount.
 * Loads saved settings and initializes layout system.
 * Theme switching is now handled by ThemeProvider based on settings.mode.
 * Adapted from Vuexy for Vite React.
 */

// React Imports
import { useEffect } from 'react';

// Type Imports
import type { SystemMode } from '@core/types';

// Hook Imports
import { useSettings } from './useSettings';

/**
 * Hook to initialize layout on mount.
 * @param colorSchemeFallback - Fallback color scheme if system preference cannot be detected (unused, kept for compatibility)
 */
const useLayoutInit = (colorSchemeFallback: SystemMode) => {
  // Intentionally unused for now; keep signature compatible with Vuexy-style API.
  void colorSchemeFallback;

  // Hooks
  const { settings } = useSettings();

  useEffect(() => {
    // Layout initialization logic can be added here if needed
    // Theme switching is now handled by ThemeProvider based on settings.mode
    // Settings are automatically loaded from localStorage via Zustand persist middleware
    
    // This hook is kept for future layout initialization needs
    // Currently, settings are loaded automatically by Zustand persist middleware
  }, [settings]);

  // This hook does not return anything as it is only used to initialize layout on mount
};

export default useLayoutInit;
